// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import request from '../_helpers/request';

export const userService = {
    login,
    newLogin,
    logout,
    getAll,
    UpdatePassword,
    UpPasswordOrIsVerifyByAccountUserId,
    GetLoginInfo,
    loginUsingToken,
    GetRelatedDate,
    GetSysCompanySponsorType,
    GetSysCompanySubmittedStatus,
    GetSysAccountSponsorsEBooth,
    VerifyJWT,
    GetUserPermission,
    checkLoginName,
    sendVerification,
    GetRoleOptions,
    AddOrEditRole,
    AddOrEditRoleByAdministrator,
    CheckUserRoleAccount,
    DelRole,
    DelRoleByAdministrator,
    CheckRole,
    GetUserDetail,
    GetUserDetailByAdministrator,
    GetUserMyUser,
    GetUserMyUserByAdministrator,
    GetUserMyUserForOperationLog,
    GetUserMyUserForOperationLogByAdministrator,
    GetOpLogOperatorProfileByAdministrator,
    GetUserMyAccount,
    GetUserMyAccount_Verify,
    GetCurrentDisplayContactCard,
    EncryptText,
};

/**
 * 旧版登录接口（已改为内部调用 newLogin，保持向后兼容）
 * 现在使用 newLogin 接口，返回格式与 newLogin 一致：{ isSuccessful: true, statusCode: 200, data: {...} }
 * @param {string} username - 登录名
 * @param {string} password - 密码（明文，内部会加密）
 * @param {string} typename - Geetest 验证码类型
 * @param {string} lot_number - Geetest 验证码参数
 * @param {string} captcha_output - Geetest 验证码参数
 * @param {string} pass_token - Geetest 验证码参数
 * @param {string} gen_time - Geetest 验证码参数
 * @returns {Promise} 登录结果，格式与 newLogin 一致
 */
async function login(username, password,typename,lot_number,captcha_output,pass_token,gen_time) {
    // 使用 newLogin 接口替换旧 login 接口
    // loginType 设为 'username'（对应 newLogin 的 'ALL'）
    // 其他参数直接传递
    return newLogin(
        username,
        password,
        'username',  // loginType: 旧 login 使用用户名登录，对应 'ALL'
        typename,
        lot_number,
        captcha_output,
        pass_token,
        gen_time,
        null,        // verifyGuid: 旧 login 不使用验证码
        null,        // verifyCode: 旧 login 不使用验证码
        false,       // isVerifyCode: 旧 login 使用密码登录
        null,        // countryId: 旧 login 不使用国家ID
        undefined    // skipValidate: 旧 login 不使用 SkipValidate
    );
}

/**
 * 基于输入值和前端传入的 loginType 计算后端期望的 LoginType
 * 新规则（2026-01-20）：
 * - RootLogin 输入框：优先 RootLogin；未命中则 People
 * - Email 输入框：Email
 * - Phone 输入框：Phone（可带 countryId）
 * - ALL 仅表示 RootLogin/People 收敛；不再包含 Email/Phone
 */
function normalizeLoginType(rawType, username) {
    const value = (username || '').trim();
    const lowerType = String(rawType || '').toLowerCase();

    // 根据账号内容推断（与后端统一分流保持一致）
    const inferFromValue = () => {
        if (value.includes('@')) return 'Email';
        if (/^\d+$/.test(value)) return 'Phone';
        if (/^c/i.test(value)) return 'RootLogin';
        if (value) return 'People';
        return 'RootLogin';
    };

    switch (lowerType) {
        case 'email':
        case 'emailotp':
            return 'Email';
        case 'mobile':
        case 'phone':
        case 'mobileotp':
            return 'Phone';
        case 'rootlogin':
        case 'root':
            return 'RootLogin';
        case 'people':
            return 'People';
        case 'all':
        case 'username':
        case 'accountid':
        case '':
            return inferFromValue();
        default:
            // 未识别的类型时，回退到基于输入值的推断，避免误传 ALL
            return inferFromValue();
    }
}

/**
 * 新版本登录接口（使用 NewLoginParam）- 用于 new-login 页面
 * @param {string} username - 登录名（username/email/mobile）
 * @param {string} password - 密码（明文，内部会加密）
 * @param {string} loginType - 登录类型：'username'/'email'/'mobile'（用于确定 loginType 字段）
 * @param {string} typename - 验证码相关字段
 * @param {string} lot_number - Geetest 验证码参数
 * @param {string} captcha_output - Geetest 验证码参数
 * @param {string} pass_token - Geetest 验证码参数
 * @param {string} gen_time - Geetest 验证码参数
 * @param {string} verifyGuid - 验证码 GUID（email/mobile 登录时使用，可选）
 * @param {string} verifyCode - 验证码（email/mobile 登录时使用，可选）
 * @param {boolean} isVerifyCode - 是否使用验证码登录（email/mobile 使用验证码登录时为 true，否则为 false）
 * @param {number} countryId - 国家ID（仅当 loginType = "Phone" 时使用，可选）
 * @returns {Promise} 登录结果
 */
async function newLogin(username, password, loginType, typename, lot_number, captcha_output, pass_token, gen_time, verifyGuid, verifyCode, isVerifyCode, countryId, skipValidate) {
    // 1. 加密密码
    var encryptApiUrl = "EMPBackend/EncryptText";
    var encryptParams = JSON.stringify({ "text": password });

    var response = await request.post(encryptApiUrl, encryptParams);

    if (response.statusCode != 200) {
        return Promise.reject(new Error('Password encryption failed'));
    }

    // 2. 规范化 loginType（根/People/Email/Phone 收敛；不再盲目传 ALL）
    const normalizedLoginType = normalizeLoginType(loginType || 'username', username);
    
    // 3. 确定登录方式 type（email/mobile 使用验证码，其他使用密码）
    let loginMethodType = 'password';
    if (normalizedLoginType === 'Email' || normalizedLoginType === 'Phone') {
        // 如果有验证码，使用 email/mobile 登录方式
        if (verifyGuid && verifyCode) {
            loginMethodType = normalizedLoginType === 'Email' ? 'email' : 'mobile';
        }
    }

    // 4. 构建登录参数（对应后端 NewLoginParam）
    // 注意：当 type == "password" 时，后端需要验证 Geetest 验证码，需要提供 lot_number, captcha_output, pass_token, gen_time, typename
    // 当 type == "email" 或 "mobile" 时，后端需要验证 verification 中的 VerifyGuid 和 VerifyCode
    
    var url = "EMPBackend/NewLogin";
    var paramsObj = {
        "username": username,                    // 登录名
        "password": response.data.text,          // 加密后的密码
        "passwordVector": response.data.vector,  // 密码向量
        "type": loginMethodType,                 // 登录方式：'password'/'email'/'mobile'
        "loginType": normalizedLoginType,        // 账号类型：'ALL'/'Email'/'Phone'/'RootLogin'/'People'
        "typename": typename || "CPS_Login",     // Geetest 验证码类型（当 type == "password" 时必需，默认 "CPS_Login"）
        "lot_number": lot_number || "",          // Geetest 验证码参数（当 type == "password" 时必需）
        "captcha_output": captcha_output || "",  // Geetest 验证码参数（当 type == "password" 时必需）
        "pass_token": pass_token || "",          // Geetest 验证码参数（当 type == "password" 时必需）
        "gen_time": gen_time || "",              // Geetest 验证码参数（当 type == "password" 时必需）
        "isVerifyCode": isVerifyCode || false,   // 是否使用验证码登录（email/mobile 使用验证码登录时为 true，否则为 false）
        "verification": {
            "VerifyGuid": verifyGuid || "",      // 验证码 GUID（当 type == "email" 或 "mobile" 时必需）
            "VerifyCode": verifyCode || ""       // 验证码（当 type == "email" 或 "mobile" 时必需）
        },
        "action": {
            "LangId": parseInt(localStorage.getItem("currentLangId")) || 1252,
            "IP": window.location.host,
            "URL": window.location.href,
            "Referral": document.referrer,
            "BAgent": window.navigator.userAgent
        }
    };
    
    // 仅当 loginType = "Phone" 时添加 countryId
    if (normalizedLoginType === 'Phone' && countryId !== undefined && countryId !== null) {
        paramsObj.countryId = countryId;
    }
    
    // 添加 SkipValidate 参数（当 skipValidate 为 true 时，传递 "1"）
    if (skipValidate === true || skipValidate === "1") {
        paramsObj.SkipValidate = "1";
    }
    
    var params = JSON.stringify(paramsObj);

    // 5. 发送登录请求
    return request.post(url, params)
        .then(async res => {
            // 只有当登录成功且 res.data 是对象（不是错误消息字符串）时才处理
            if (res.isSuccessful && res.data && typeof res.data === 'object' && res.data.empCompanyId) {
                try {
                    res.data.extraPermissions = await GetUserExtraPermission({accountid : res.data.empCompanyId});
                    localStorage.setItem('user', JSON.stringify(res.data));
                } catch (error) {
                    console.error('Failed to get extra permissions:', error);
                    // 即使获取权限失败，也保存用户数据
                    localStorage.setItem('user', JSON.stringify(res.data));
                }
            }
            return res;
        })
        .catch(error => {
            console.error('NewLogin error:', error);
            // 返回错误格式，与后端返回格式一致
            return {
                isSuccessful: false,
                statusCode: error?.response?.status || 500,
                data: error?.response?.data?.data || error.message || '登录失败',
                Msg: error?.response?.data?.Msg || [error.message || '登录失败']
            };
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    var url = "EMPBackend/Getuser"
    var params = { params: null };
    return request.get(url, params)
}


function UpdatePassword(oldPassword, newPassword) {

    var url = "EMPBackend/UpdatePasswordWithOldPassword";
    var params = {
        "oldPassword": oldPassword
        , "newPassword": newPassword
        , "action": {
            "LangId": localStorage.getItem("currentLangId")
            , "IP": window.location.host
            , "URL": window.location.href
            , "Referral": document.referrer
            , "BAgent": window.navigator.userAgent
        }
    };

    return request.post(url, params)
        .then(res => {
            return res.data
        })
}

/**
 * 重置密码接口 - 通过 AccountUserId 更新密码或标记验证
 * 支持两种操作类型：UPDATE_PASSWORD（更新密码）和 MARK_VERIFY（标记验证）
 * @param {Object} params - 参数对象
 * @param {string} params.actionType - 操作类型：'UPDATE_PASSWORD' 或 'MARK_VERIFY'（默认 'UPDATE_PASSWORD'）
 * @param {number|null} params.accountUserId - 用户账户ID（MARK_VERIFY 场景必填，UPDATE_PASSWORD 场景可为 0/null）
 * @param {string} params.newPassword - 新密码（明文，UPDATE_PASSWORD 场景必需，将在此方法中加密）
 * @param {string} params.loginUser - 登录用户名（邮箱或手机号，可选，用于反查 AccountUserId）
 * @param {string} params.loginType - 登录类型：'Email' 或 'Phone'（MARK_VERIFY 场景必需）
 * @param {string} params.loginValue - 登录值（邮箱或手机号，MARK_VERIFY 场景必需，可由 loginUser 自动推断）
 * @param {number} params.countryId - 国家ID（Phone 场景必需，可选，默认0）
 * @param {number} params.userId - 用户ID/AccountId（可选，默认0）
 * @returns {Promise<Object>} 返回 Promise，resolve 值为后端返回的 ValidationResult<Object>
 */
async function UpPasswordOrIsVerifyByAccountUserId(params) {
    const url = "EMPBackend/UpPasswordOrIsVerifyByAccountUserId";
    
    // 确定操作类型，默认为 UPDATE_PASSWORD（保持向后兼容）
    const actionType = (params.actionType || 'UPDATE_PASSWORD').toUpperCase().trim();
    
    // 语言ID
    const langId = parseInt(localStorage.getItem("currentLangId")) || 1252;
    
    let requestParams = {
        ActionType: actionType,
        AccountUserId: params.accountUserId ?? 0,
        CountryId: params.countryId ?? 0,
        UserId: params.userId ?? 0,
        action: {
            LangId: langId,
            IP: window.location.host,
            URL: window.location.href,
            Referral: document.referrer || '',
            BAgent: window.navigator.userAgent
        }
    };
    
    if (actionType === 'UPDATE_PASSWORD') {
        // UPDATE_PASSWORD 场景：需要密码
        if (!params.newPassword) {
            return Promise.resolve({
                isSuccessful: false,
                statusCode: 400,
                data: null,
                systemErrorMsg: [],
                msg: ['密码不能为空']
            });
        }
        
        // 1. 加密密码（Value 需要前端加密后的字符串）
        const encryptApiUrl = "EMPBackend/EncryptText";
        const encryptParams = JSON.stringify({ text: params.newPassword });

        let encryptResponse;
        try {
            encryptResponse = await request.post(encryptApiUrl, encryptParams);
        } catch (error) {
            console.error("Encrypt password failed:", error);
            return {
                isSuccessful: false,
                statusCode: error?.response?.status || 500,
                data: null,
                systemErrorMsg: [error.message || "Encrypt password failed"],
                msg: [error.message || "Encrypt password failed"],
            };
        }

        if (!encryptResponse || encryptResponse.statusCode !== 200) {
            return {
                isSuccessful: false,
                statusCode: encryptResponse?.statusCode || 500,
                data: null,
                systemErrorMsg: encryptResponse?.systemErrorMsg || [],
                msg: encryptResponse?.msg || ["Encrypt password failed"],
            };
        }

        const encryptedPassword = encryptResponse.data?.text || "";
        const passwordVector = encryptResponse.data?.vector || "";
        
        requestParams.Value = encryptedPassword;
        requestParams.PasswordVector = passwordVector;
        
        if (params.loginUser) {
            requestParams.LoginUser = params.loginUser;
        }
    } else if (actionType === 'MARK_VERIFY') {
        // MARK_VERIFY 场景：标记邮箱或手机为已验证
        if (params.accountUserId <= 0) {
            return Promise.resolve({
                isSuccessful: false,
                statusCode: 400,
                data: null,
                systemErrorMsg: [],
                msg: ['AccountUserId 不能为空']
            });
        }
        
        // 如果提供了 loginUser，自动推断 LoginType 和 LoginValue
        if (params.loginUser) {
            const loginValue = params.loginUser.trim();
            if (loginValue.includes('@')) {
                requestParams.LoginType = 'Email';
                requestParams.LoginValue = loginValue;
            } else {
                requestParams.LoginType = 'Phone';
                requestParams.LoginValue = loginValue;
            }
        } else {
            // 使用直接提供的 loginType 和 loginValue
            if (params.loginType) {
                requestParams.LoginType = params.loginType;
            }
            if (params.loginValue) {
                requestParams.LoginValue = params.loginValue;
            }
        }
        
        // 验证必需参数
        if (!requestParams.LoginType || !requestParams.LoginValue) {
            return Promise.resolve({
                isSuccessful: false,
                statusCode: 400,
                data: null,
                systemErrorMsg: [],
                msg: ['MARK_VERIFY 场景下必须提供 LoginType 和 LoginValue（或 LoginUser）']
            });
        }
        
        // Phone 场景需要 CountryId
        if (requestParams.LoginType.toUpperCase() === 'PHONE' && (!requestParams.CountryId || requestParams.CountryId <= 0)) {
            return Promise.resolve({
                isSuccessful: false,
                statusCode: 400,
                data: null,
                systemErrorMsg: [],
                msg: ['Phone 验证必须提供 CountryId']
            });
        }
    } else {
        return Promise.resolve({
            isSuccessful: false,
            statusCode: 400,
            data: null,
            systemErrorMsg: [],
            msg: [`不支持的操作类型：${actionType}，仅支持 UPDATE_PASSWORD 或 MARK_VERIFY`]
        });
    }

    const requestBody = JSON.stringify(requestParams);
    
    return request
        .post(url, requestBody)
        .then((res) => {
            return res;
        })
        .catch((error) => {
            console.error("UpPasswordOrIsVerifyByAccountUserId error:", error);
            // 返回错误格式，与后端返回格式一致
            return {
                isSuccessful: false,
                statusCode: error?.response?.data?.statusCode || error?.response?.status || 500,
                data: error?.response?.data?.data || null,
                systemErrorMsg:
                    error?.response?.data?.systemErrorMsg ||
                    error?.response?.data?.SystemErrorMsg ||
                    [],
                msg:
                    error?.response?.data?.msg ||
                    error?.response?.data?.Msg ||
                    [error.message || (actionType === 'UPDATE_PASSWORD' ? "密码更新失败" : "验证标记失败")],
            };
        });
}

function GetLoginInfo() {

    var url = "EMPBackend/GetLoginInfo";
    var params = {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    };

    return request.post(url, params)
        .then(res => {
            return res.data;
        })
}

function GetUserInfo() {

    var url = "EMPBackend/GetUserInfo";
    var params = {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    };

    return request.post(url, params)
        .then(res => {
            return res;
        })
}

async function loginUsingToken(token) {
    // normalize token (some callers pass "Bearer xxx" or URL-encoded token)
    let normalizedToken = token;
    try {
        normalizedToken = decodeURIComponent(String(token || '').trim());
    } catch (e) {
        normalizedToken = String(token || '').trim();
    }
    normalizedToken = normalizedToken.replace(/^Bearer\s+/i, '').trim();

    if (!normalizedToken) {
        return Promise.reject(new Error('Missing token'));
    }

    localStorage.setItem('user', JSON.stringify({ 'token': normalizedToken }));
    return GetUserInfo().then(async res => {
        if (res.isSuccessful) {
            var userInfo = res.data;
            userInfo.token = normalizedToken;
            
            userInfo.extraPermissions = await GetUserExtraPermission({accountid : res.data.empCompanyId})
            localStorage.setItem('user', JSON.stringify(userInfo));
            return userInfo;
        } else {
            return res.isSuccessful;
        }
    });


}


function GetRelatedDate() {

    var url = "EMPBackend/GetRelatedDate";
    var params = {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    };

    return request.post(url, params)
        .then(res => {
            return res;
        })
}

function GetSysCompanySponsorType(query) {
    return request({
        url: 'EMPBackend/GetSysCompanySponsorType',
        method: 'post',
        params: query
    });
}
function GetSysCompanySubmittedStatus(query) {

    var url = "EMPBackend/GetSysCompanySubmittedStatus";
    var params = {
        "LangId": localStorage.getItem("currentLangId")
        , "IP": window.location.host
        , "URL": window.location.href
        , "Referral": document.referrer
        , "BAgent": window.navigator.userAgent

    };

    return request.post(url, params)
        .then(res => {
            return res;
        })
}

function GetSysAccountSponsorsEBooth(query) {
    return request({
        url: 'EMPBackend/GetSysAccountSponsorsEBooth',
        method: 'post',
        params: query
    });
}

async function GetUserExtraPermission(query){
    return request({
        url: 'EMPBackend/GetUserExtraPermission',
        method: 'post',
        params:query
    }).then(
        res => {  
            if(res.isSuccessful){
                return res.data
            }
            //return empty extra permission array
            return []
        })
}

async function VerifyJWT(){
    var url = 'EMPBackend/VerifyJWT'
    return request.post(url)
    .then(
        res => {  
            if(res.isSuccessful){
                return res.data
            }
            //return empty extra permission array
            return false
    })
}

function GetUserPermission(){
    var url = 'EMPBackend/GetUserPermissions'
    return request.post(url)
    .then(
        res => {  
            if(res.isSuccessful){
                return res.data
            }
            return false
    })
}

async function GetUserMyAccount(query) {
    return await request({
      url: 'EMPBackend/GetUserMyAccount',
      method: 'post',
      params: query
    });
}
async function GetUserMyAccount_Verify(query) {
    return await request({
      url: 'EMPBackend/GetUserMyAccount_Verify',
      method: 'post',
      params: query
    });
}

async function EncryptText(password) {
    return await request({
      url: 'EMPBackend/EncryptText',
      method: 'post',
      data: JSON.stringify({ "text": password })
    }).then(res=>{
        if(res.isSuccessful){
            return res.data;
        }
    });
}

async function GetUserMyUser(query) {
    // 使用 data（请求体）而不是 params（查询字符串）
    // 因为后端 ASP.NET Core 的 [FromBody] 或默认模型绑定会从请求体读取参数
    return await request({
      url: 'EMPBackend/GetUserMyUser',
      method: 'post',
      data: query
    });
}

/**
 * 超级管理员获取用户信息接口
 * 用于管理员查看其他公司的用户列表
 * 注意：ASP.NET Core 的 POST 请求，简单类型参数（int）默认从查询字符串绑定，不是从请求体
 * @param {Object} query - 查询参数 { accountId: number, accountUserId: number }
 * @returns {Promise} 用户列表数据
 */
async function GetUserMyUserByAdministrator(query) {
    return await request({
      url: 'EMPBackend/GetUserMyUserByAdministrator',
      method: 'post',
      params: query  // 使用 params（查询字符串）而不是 data（请求体）
    });
}

/** 操作日志用户列表；query.uiLangId 可选（936/950/1252） */
async function GetUserMyUserForOperationLog(query) {
    return await request({
      url: 'EMPBackend/GetUserMyUserForOperationLog',
      method: 'post',
      data: query || {},
    });
}

async function GetUserMyUserForOperationLogByAdministrator(query) {
    return await request({
      url: 'EMPBackend/GetUserMyUserForOperationLogByAdministrator',
      method: 'post',
      params: query,
    });
}

/** 操作日志：按 AccountUserId 解析 EXH 等未映射到该公司的操作人 */
async function GetOpLogOperatorProfileByAdministrator(query) {
    return await request({
      url: 'EMPBackend/GetOpLogOperatorProfileByAdministrator',
      method: 'post',
      params: query,
    });
}

async function GetUserDetail(query) {
    return await request({
      url: 'EMPBackend/GetUserDetail',
      method: 'post',
      params: query
    });
}
async function GetUserDetailByAdministrator(query) {
    return await request({
      url: 'EMPBackend/GetUserDetailByAdministrator',
      method: 'post',
      params: query
    });
}
async function GetCurrentDisplayContactCard(query) {
    return await request({
      url: 'EMPBackend/GetCurrentDisplayContactCard',
      method: 'post',
      params: query
    });
}

async function   AddOrEditRole(data) {
    return await request({
      url: 'EMPBackend/AddOrEditRole',
      method: 'post',
      data: data
    });
}
async function AddOrEditRoleByAdministrator(data, accountId, accountUserId) {
    return await request({
      url: 'EMPBackend/AddOrEditRoleByAdministrator',
      method: 'post',
      data: data,
      params: {
        accountId: accountId,
        accountUserId: accountUserId
      }
    });
}
async function   CheckUserRoleAccount(data) {
    return await request({
      url: 'EMPBackend/CheckUserRoleAccount',
      method: 'post',
      data: data
    });
}

async function   DelRole(query) {
    return await request({
      url: 'EMPBackend/DelRole',
      method: 'post',
      params: query
    });
}
async function DelRoleByAdministrator(query) {
    return await request({
      url: 'EMPBackend/DelRoleByAdministrator',
      method: 'post',
      params: query
    });
}

async function CheckRole(query) {
    return await request({
      url: 'EMPBackend/CheckRole',
      method: 'post',
      params: query
    });
}

async function GetRoleOptions(query) {
    return await request({
      url: 'EMPBackend/GetRoleOptions',
      method: 'get',
      params: query
    });
}

/**
 * 检查登录名是否存在（不验证密码）- 用于 new-login 页面
 * 
 * 对应后端接口：CheckLoginName (NewCheckLoginNameParam)
 * 返回格式：CheckLoginNameResult
 *   - exists: bool - 登录名是否存在
 *   - loginType: string - 匹配到的类型（"username" / "email" / "mobile"）
 *   - message: string - 提示信息
 * 
 * @param {string} loginName - 登录名（可以是 username、email 或 mobile）
 * @param {string} loginType - 登录类型：'username'/'email'/'mobile'（可选，默认 'username' -> 'ALL'）
 * @param {number} countryId - 国家ID（仅当 loginType = "Phone" 时使用，可选）
 * @returns {Promise<Object>} 返回 Promise，resolve 值为：
 *   {
 *     exists: boolean,        // 登录名是否存在（对应后端 CheckLoginNameResult.exists）
 *     loginType: string,      // 匹配到的类型："username" / "email" / "mobile"（对应后端 CheckLoginNameResult.loginType）
 *     message: string,        // 提示信息（对应后端 CheckLoginNameResult.message）
 *     statusCode: number,     // HTTP 状态码
 *     isSuccessful: boolean   // 请求是否成功
 *   }
 */
function checkLoginName(loginName, loginType, countryId) {
    if (!loginName || !loginName.trim()) {
        return Promise.resolve({
            exists: false,
            loginType: null,
            message: '登录名不能为空',
            statusCode: 400,
            isSuccessful: false
        });
    }

    // 规范化 loginType（email->Email, mobile->Phone, 其他->ALL）
    const normalizedLoginType = normalizeLoginType(loginType || 'username', loginName);
    
    var url = "EMPBackend/CheckLoginNameNew";
    var paramsObj = {
        "loginName": loginName.trim(),
        "loginType": normalizedLoginType,  // 对应后端 NewCheckLoginNameParam.loginType
        "action": {
            "LangId": parseInt(localStorage.getItem("currentLangId")) || 1252,
            "IP": window.location.host,
            "URL": window.location.href,
            "Referral": document.referrer,
            "BAgent": window.navigator.userAgent
        }
    };
    
    // 仅当 loginType = "Phone" 时添加 countryId
    if (normalizedLoginType === 'Phone' && countryId !== undefined && countryId !== null) {
        paramsObj.countryId = countryId;
    }
    
    var params = JSON.stringify(paramsObj);

    return request.post(url, params)
        .then(res => {
            // 后端返回格式：ValidationResult<CheckLoginNameResult>
            // res.data 就是 CheckLoginNameResult 对象
            if (res && res.isSuccessful && res.data) {
                // 确保类型正确（后端返回的是 bool，但 JSON 解析后可能变成其他类型）
                return {
                    exists: Boolean(res.data.exists),           // 确保是 boolean
                    loginType: res.data.loginType || null,      // "username" / "email" / "mobile"
                    message: res.data.message || '',            // 提示信息
                    statusCode: res.statusCode || 200,
                    isSuccessful: true
                };
            }
            
            // 请求失败或数据格式不正确
            return {
                exists: false,
                loginType: null,
                message: res?.data?.message || res?.Msg?.join(';') || 'Invalid response from server',
                statusCode: res?.statusCode || 500,
                isSuccessful: false
            };
        })
        .catch(error => {
            console.error('CheckLoginName error:', error);
            return {
                exists: false,
                loginType: null,
                message: error?.response?.data?.message || error.message || 'Failed to check login name',
                statusCode: error?.response?.status || 500,
                isSuccessful: false
            };
        });
}

/**
 * 统一验证发送接口（Email/SMS 统一）
 * @param {Object} params - 发送参数
 * @param {string} params.channel - 渠道：'email' 或 'mobile'，默认 'mobile'
 * @param {string} params.sendType - 类型：'verificationCode'（验证码）、'retrieveAccount'（找回账号）、'retrievePassword'（找回密码），默认 'verificationCode'
 * @param {string} params.typename - 滑块验证参数：验证码类型，默认 'CPS_Login'
 * @param {string} params.lot_number - 滑块验证参数
 * @param {string} params.captcha_output - 滑块验证参数
 * @param {string} params.pass_token - 滑块验证参数
 * @param {string} params.gen_time - 滑块验证参数
 * @param {string} params.password - 找回账号/密码时需要的加密密码（可选）
 * @param {string} params.passwordVector - 找回账号/密码时需要的密码向量（可选）
 * @param {string} params.email - Email 渠道必填：接收邮箱
 * @param {number} params.langId - Email 渠道可选：语言ID（1252英文/936简体/950繁体），默认1252
 * @param {string} params.CellNum - Mobile 渠道必填：手机号
 * @param {string} params.showid - Mobile 渠道必填：展会ID
 * @param {number} params.RLang - Mobile 渠道必填：语言代码
 * @param {string|boolean} params.isInternational - Mobile 渠道可选：国际短信标识，"true"/"1" 为 true，其余为 false
 * @returns {Promise<Object>} 返回 Promise，resolve 值为后端返回的 ValidationResult<Object>
 */
function sendVerification(params) {
    // 构建 FormData
    const formData = new FormData();
    
    // 获取语言ID，如果没有则使用默认值1252（英文）
    var langId = localStorage.getItem("currentLangId");
    if (!langId) {
        langId = "1252"; // 默认英文
    }
    
    // 通用参数
    formData.append('channel', (params.channel || 'mobile').toLowerCase());
    formData.append('sendType', (params.sendType || 'verificationCode').toLowerCase());
    
    // 滑块验证参数（必填）
    formData.append('typename', params.typename || 'CPS_Login');
    formData.append('lot_number', params.lot_number || '');
    formData.append('captcha_output', params.captcha_output || '');
    formData.append('pass_token', params.pass_token || '');
    formData.append('gen_time', params.gen_time || '');
    
    // 找回账号/密码时的密码参数（可选）
    if (params.password) {
        formData.append('password', params.password);
    }
    if (params.passwordVector) {
        formData.append('passwordVector', params.passwordVector);
    }
    
    // Email 渠道参数
    if (params.channel && params.channel.toLowerCase() === 'email') {
        if (params.email) {
            formData.append('email', params.email);
        }
        if (params.langId !== undefined && params.langId !== null) {
            formData.append('langId', params.langId.toString());
        }
    }
    // Mobile 渠道参数
    else {
        if (params.CellNum) {
            formData.append('CellNum', params.CellNum);
        }
        // Mobile 渠道建议传递 countryId 和 countryTelCode
        if (params.countryId !== undefined && params.countryId !== null) {
            formData.append('countryId', params.countryId.toString());
        }
        if (params.countryTelCode !== undefined && params.countryTelCode !== null && params.countryTelCode !== '') {
            formData.append('countryTelCode', params.countryTelCode.toString());
        }
        if (params.showid) {
            formData.append('showid', params.showid.toString());
        }
        if (params.RLang !== undefined && params.RLang !== null) {
            formData.append('RLang', params.RLang.toString());
        }
        if (params.isInternational !== undefined && params.isInternational !== null) {
            const isIntl = params.isInternational === true || params.isInternational === 'true' || params.isInternational === '1';
            formData.append('isInternational', isIntl ? 'true' : 'false');
        }
        // Mobile 渠道的 langId（用于找回账号/密码）
        if (params.langId !== undefined && params.langId !== null) {
            formData.append('langId', params.langId.toString());
        }
    }
    
    // 添加 action.LangId 参数（推荐传递，用于日志记录）
    // 注意：对于 form-data，action 对象需要作为嵌套字段传递
    // 这里添加 action.LangId 作为单独的字段
    formData.append('action.LangId', langId);
    formData.append('action.IP', window.location.host);
    formData.append('action.URL', window.location.href);
    formData.append('action.Referral', document.referrer);
    formData.append('action.BAgent', window.navigator.userAgent);
    
    var url = "EMPBackend/SendVerification";
    
    // 使用 axios 直接发送，因为需要 form-data 格式
    // request 是 axios 实例，支持传入配置对象
    return request.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    .then(res => {
        return res;
    })
    .catch(error => {
        console.error('SendVerification error:', error);
        // 返回错误格式，与后端返回格式一致
        return {
            isSuccessful: false,
            statusCode: error?.response?.data?.statusCode || error?.response?.status || 500,
            data: error?.response?.data?.data || null,
            systemErrorMsg: error?.response?.data?.systemErrorMsg || error?.response?.data?.SystemErrorMsg || [],
            msg: error?.response?.data?.msg || error?.response?.data?.Msg || [error.message || '发送失败']
        };
    });
}
